import axios from '../../axios';
import * as types from './mutation-types'

export default {
	namespaced: true,
	state: () => ({
		mainBranchInfo: null
	}),
	actions: {
		async fetchAll({ commit }) {
			try {
				const res = await axios.get('/branches')
				const data = res && res?.data && Array.isArray(res.data) ? res.data : []
				if (data.length > 0) {
					commit(types.BRANCHES, data[0])
				} else {
					commit(types.BRANCHES, null)
				}
				return res
			} catch (err) {
				console.log(err, 'error on get branches')
				commit(types.BRANCHES, null)
				return null
			}
		}
	},
	getters: {
		getContacts: (state) => (state.mainBranchInfo && state.mainBranchInfo.contacts) || {}
	},
	mutations: {
		[types.BRANCHES](state, payload) {
			state.mainBranchInfo = payload
		}
	}
}